import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { Observable, throwError } from 'rxjs';
import { tap, timeout, catchError, finalize } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { LoaderService } from '../services/loaderService';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { paths } from '../helpers/constants';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    private router: Router,
    private sessionTimeoutService: SessionTimeoutService,
    private loaderService: LoaderService,
    private snackBar: MatSnackBar,
    private loadingService: LoadingService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.showLoader();
    const timeoutValue = Number(request.headers.get('timeout')) || 60000;
    const isApi = request.url.includes(environment.url.api) || request.url.includes(environment.url.apiBff);

    // valor que debe proporcionarse al invocar a servicios que utilicen clientId diferente al por defecto
    // valores de ejemplo: Portabilidad o Corredores
    const dominio = request.headers.get('dominio');

    if (this.auth.isLoggedIn() && isApi) {
      const showLoading = request.headers.has('HAS_LOADING');
        request = request.clone({
          headers: showLoading
            ? request.headers.delete('HAS_LOADING')
            : request.headers,
          setHeaders: {
            Authorization: `Bearer ${this.auth.getToken()}`,
            LR_USUARIO: this.auth.getRut(),
            Sistema: 'Clientes',
            LR_CODINTER: '00000000',
            'cache-control': 'no-cache',
            'X-IBM-Client-Id': request.url.includes('col/PolicyServicing/Policy')  ? environment.service.policyServicing.clientId : this.auth.getClientId(dominio),
          },
        });
      if (showLoading) {
        this.loadingService.showLoading(request.url);
      }

      // this.auth.refresh();
    }
    return next.handle(request).pipe(
      timeout(timeoutValue),
      finalize(() => this.loadingService.hideLoading(request.url)),
      catchError(error => this.handleError(error)),
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.onEnd();
          }
        },
        (err: any) => {
          // this.snackBar.open(
          //   'Ha ocurrido un problema, inténtalo más tarde',
          //   '',
          //   { duration: 3000, panelClass: 'snack-error' } as MatSnackBarConfig
          // );
          this.onEnd();
        }
      )
    );
  }

  private onEnd(): void {
    this.hideLoader();
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }
}
